<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="full-width">
    <input matInput autocomplete="off" formControlName="Protocol" placeholder="Protocolo">
  </mat-form-field>
  <div class="full-width">
    <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <mat-checkbox formControlName="ShowAll">Ver todos</mat-checkbox>
</form>
